import {
  DisputesEdge,
  DisputeTransactionsEdge,
  PageInfo,
  Query,
} from '@varo/graphql-schema-types';
import { useEffect, useState } from 'react';
import fetchDisputeTransactionsList from 'services/graphql/queries/FetchDisputeTrasactionsList';
import { DISPUTES_TXN_MIN_SIZE } from 'shared/constants/disputes';
import { useQuery } from 'urql';

const useDisputesTransactionsList = (disputeItem: DisputesEdge) => {
  const [pageInfo, setPageInfo] = useState<PageInfo>(
    disputeItem?.node?.transactionsConnection?.pageInfo,
  );

  const [transactionsList, setTransactionsList] = useState<
    DisputeTransactionsEdge[]
  >(disputeItem?.node?.transactionsConnection?.edges);

  const [
    { data: disputesTransactionsList, error, fetching: loading },
    getDisputeTransactions,
  ] = useQuery<Query>({
    query: fetchDisputeTransactionsList,
    requestPolicy: 'cache-and-network',
    variables: {
      disputeId: disputeItem?.node?.id,
      first: DISPUTES_TXN_MIN_SIZE,
      after: pageInfo?.endCursor,
    },
    pause: true,
  });

  useEffect(() => {
    if (disputesTransactionsList?.disputeTransactions?.edges) {
      const updatedTransactions =
        disputesTransactionsList.disputeTransactions.edges;
      setTransactionsList((prevState) => [
        ...prevState,
        ...updatedTransactions,
      ]);

      setPageInfo(disputesTransactionsList?.disputeTransactions?.pageInfo);
    }
  }, [disputesTransactionsList, loading]);

  const loadMoreRecords = () => {
    if (pageInfo?.endCursor) {
      getDisputeTransactions({
        variables: {
          disputeId: disputeItem?.node?.id,
          first: DISPUTES_TXN_MIN_SIZE,
          after: pageInfo.endCursor,
        },
      });
    }
  };

  const uniqueIds = new Set<string>();
  const filteredTransactionsList = transactionsList?.filter((transaction) => {
    if (uniqueIds.has(transaction?.node?.id)) {
      return false;
    }
    uniqueIds.add(transaction?.node?.id);
    return true;
  });

  return {
    loadMoreRecords,
    transactionsList,
    pageInfo,
    loading,
    error,
    filteredTransactionsList,
  };
};

export default useDisputesTransactionsList;
